
import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AuthService } from '../../services/auth.service';
import { CommunityAuthService } from '../../services/community-auth.service';
import { MatButtonModule } from '@angular/material/button';
import { UsersService } from '../../services/user.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
  imports: [
    MatCardModule,
    MatButtonModule
]
})
export class UnauthorizedComponent {
  authService = inject(CommunityAuthService);
  userService = inject(UsersService);
  router = inject(Router);
  authenticatedUser: string | undefined;
  constructor() {
    this.authenticatedUser = this.authService.actualUsername;
  }

  async ngOnInit() {
    try {
      const user = await firstValueFrom(this.userService.getCurrentUser());
      this.router.navigate(["/"]);
      return;
    } catch (err) {
      console.error(err);
      // then stay
    }
  }

  logout() {
    this.authService.logout();
  }
}
